import React from 'react'
import { shallow } from 'enzyme'

import { Category } from '../../features/Highlight/Category'

describe('Category', () => {
  let wrapper, props, result, instance
  beforeEach(() => {
    props = {
      category: {
        rid: 1,
        category: 'guarantor',
        topics: [],
      },
      topics: [
        {
          rid: 1,
          category: 'guarantor',
          document: null,
          draft: true,
          explanation: 'Some explanation',
          guarantor: null,
          nextHighlight: {
            rid: 2,
          },
          predefined: true,
          previousHighlight: null,
          topic: 'CBR',
        },
      ],
      createHighlight: jest.fn(),
      loanId: 123,
      updateHighlight: jest.fn(),
      isBankUser: false,
      isDropDisabled: false,
      isDraggingOver: false
    },
    wrapper = shallow(<Category {...props} />)
    instance = wrapper.instance()
  })
  it('should set default states', () => {
    expect(wrapper.state('isDeleteModalOpen')).toBeFalsy();
    expect(wrapper.state('topics').length).toEqual(1)
    expect(wrapper.state('deleteHighlightId')).toBeFalsy();
  })
  describe('#onAddNewTopicClick', () => {
    it('should add a new topic to the topics ', () => {
      instance.onAddNewTopicClick()
      expect(wrapper.state('topics').length).toEqual(2)
    })
    it('should call updateTopic function', () => {
      const updateTopics = spyOn(instance, 'updateTopics')
      instance.onAddNewTopicClick()
      expect(updateTopics).toHaveBeenCalled()
    })
  })
  describe('#updateTopicList', () => {
    it('should remove the topic from the topics ', () => {
      wrapper.setState({ deleteHighlightId : props.topics[0].rid })
      instance.updateTopicList()
      expect(wrapper.state('topics').length).toEqual(0)
    })
    it('should call updateTopic function', () => {
      const updateTopics = spyOn(instance, 'updateTopics')
      instance.updateTopicList()
      expect(updateTopics).toHaveBeenCalled()
    })
  })
  describe('#onDeleteTopic', () => {
    it('should call renderDeleteConfirmation function', () => {
      const renderDeleteConfirmation = spyOn(instance, 'renderDeleteConfirmation')
      instance.onDeleteTopic(props.topics[0].rid)
      expect(renderDeleteConfirmation).toHaveBeenCalled()
    })
    it('should set deleteHighlightId ', () => {
      instance.onDeleteTopic(props.topics[0].rid)
      expect(wrapper.state('deleteHighlightId')).toEqual(props.topics[0].rid)
    })
  })
  describe('#onSaveNewTopic', () => {
    it('should call createHighlight function', () => {
      instance.onSaveNewTopic({ draft: true, editorTitle: 'title', editorContent: 'content', files: null})
      expect(props.createHighlight).toHaveBeenCalled()
    })
  })
  describe('#onUpdateExistingTopic', () => {
    it('should call updateHighlight function', () => {
      instance.onUpdateExistingTopic({ draft: true, editorTitle: 'title', editorContent: 'content', files: [] })
      expect(props.updateHighlight).toHaveBeenCalled()
    })
  })
  describe('#updateTopics', () => {
    it('should update the topics state', () => {
      let topics = wrapper.state('topics')
      expect(topics[0].rid).toEqual(props.topics[0].rid)
      topics[0].rid = 2
      instance.updateTopics(topics)
      expect(wrapper.state('topics')[0].rid).toEqual(topics[0].rid)
    })
  })
  describe('#onCloseClick', () => {
    it('should call function', () => {
      const updateTopics = spyOn(instance, 'updateTopics')
      instance.onCloseClick()
      expect(updateTopics).toHaveBeenCalled()
    })
  })
})